import { AppRemixIcon } from '@/layout/AppComponents';
import DefaultWidgetTemplate from '../DefaultWidgetTemplate';

const IntelligenceDefaultWidget = (props) => (
  <DefaultWidgetTemplate
    module={props.module}
    route="user_module_intelligence_home"
  />
);

export default IntelligenceDefaultWidget;
